import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

const Styling = styled.div`
  .cls-1 {
    fill: ${({ color }) => color};
  }
`;

const MagnifyingGlass = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <Styling color={iconColor}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 18.94824 18.94824"
      >
        <title>{iconTitle}</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_21" data-name="Layer 21">
            <path
              className="cls-1"
              d="M17.90918,16.84473l-4.227-4.227a7.71337,7.71337,0,1,0-1.06061,1.06048l4.22711,4.22711a.74992.74992,0,0,0,1.06055-1.06054ZM3.32178,12.11426a6.22,6.22,0,1,1,8.79638,0A6.17861,6.17861,0,0,1,3.32178,12.11426Z"
            />
          </g>
        </g>
      </svg>
    </Styling>
  );
};

MagnifyingGlass.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

MagnifyingGlass.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(MagnifyingGlass);
